import {
  columnVisibilityFeature,
  rowSortingFeature,
  tableFeatures
} from '@tanstack/react-table';

/**
 * The TanStack Table features every Rhino table registers.
 *
 * v9 tree-shakes features: an API exists on the table, row, column, header and
 * cell objects only when its feature is listed here. `rowSortingFeature` backs
 * the sortable column headers (`column.getCanSort`, `column.toggleSorting`, the
 * `sorting` state slice); `columnVisibilityFeature` backs
 * `row.getVisibleCells()`. The core row model is automatic in v9, and sorting is
 * server side (`manualSorting: true`), so no `sortedRowModel` slot is needed.
 *
 * Defined at module scope — `tableFeatures()` is meant to be static, not rebuilt
 * per render.
 */
export const rhinoTableFeatures = tableFeatures({
  columnVisibilityFeature,
  rowSortingFeature
});

export type RhinoTableFeatures = typeof rhinoTableFeatures;
